import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import DashboardLayout from "../../layouts/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

import OverviewTab from "./Tabs/OverviewTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

const TenantChangesPage = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <DashboardLayout>
      <MDBox>
        <MDTypography variant="h4" fontWeight="medium" color="dark" mb={3}>
          Mieterwechsel
        </MDTypography>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Übersicht" />
          </Tabs>
        </Box>

        {/* Übersicht Tab */}
        <TabPanel value={tabValue} index={0}>
          <OverviewTab />
        </TabPanel>
      </MDBox>
    </DashboardLayout>
  );
};

export default TenantChangesPage;
